import { env } from 'config';
import {
  PayinCancelReasons,
  PayinIntegrationHealth,
  PayinLossPoints,
  PayinNotAssignedReasons,
  PayinProviderConversion,
  PayinProviderErrorGroupRow,
  PayinTimings,
  PaginatedData,
  QueryParams,
} from 'types';
import { apiUtils } from 'utils';

const url = `${env.apiUrl}/p2p-providers-payin-statistics`;

const getConversion = async (
  params: QueryParams,
): Promise<PayinProviderConversion> =>
  (await apiUtils.getWithQueryParams(`${url}/conversion`, params)).data;

const getErrors = async (
  params: QueryParams,
): Promise<PaginatedData<PayinProviderErrorGroupRow>> =>
  (await apiUtils.getWithQueryParams(`${url}/errors`, params)).data;

const getCancelReasons = async (
  params: QueryParams,
): Promise<PayinCancelReasons> =>
  (await apiUtils.getWithQueryParams(`${url}/cancel-reasons`, params)).data;

const getNotAssignedReasons = async (
  params: QueryParams,
): Promise<PayinNotAssignedReasons> =>
  (await apiUtils.getWithQueryParams(`${url}/not-assigned-reasons`, params))
    .data;

const getLossPoints = async (params: QueryParams): Promise<PayinLossPoints> =>
  (await apiUtils.getWithQueryParams(`${url}/loss-points`, params)).data;

const getTimings = async (params: QueryParams): Promise<PayinTimings> =>
  (await apiUtils.getWithQueryParams(`${url}/timings`, params)).data;

const getIntegrationHealth = async (
  params: QueryParams,
): Promise<PayinIntegrationHealth> =>
  (await apiUtils.getWithQueryParams(`${url}/integration-health`, params)).data;

export const payinProviderStatisticsApi = {
  getConversion,
  getErrors,
  getCancelReasons,
  getNotAssignedReasons,
  getLossPoints,
  getTimings,
  getIntegrationHealth,
};
